// src/services/AuthService.js

import { isValidValue } from "utils";
import { authApi } from "./api";

export const SESSION_EXPIRED =
  "Your session has expired. Please log in again to continue.";

const AuthService = {
  /**
   * Returns access token
   */
  getAccessToken() {
    const accessToken = localStorage.getItem("access_token");
    if (!isValidValue(accessToken))
      return { token: null, refresh: null, username: null };
    return JSON.parse(accessToken);
  },
  /**
   * Returns user session
   */
  getUserSession() {
    const userSession = localStorage.getItem("userSession");
    if (!userSession) return null;
    return JSON.parse(userSession);
  },

  /**
   * 🔄 Refresh tokens using own api
   */
  async refreshToken() {
    const { token, refresh, username } = this.getAccessToken();
    if (!isValidValue(refresh))
      throw new Error(
        "No refresh token found. Please log in again to continue.",
      );
    if (!isValidValue(token))
      throw new Error(
        "No access token found. Please log in again to continue.",
      );

    try {
      const params = { access_token: token, refresh_token: refresh };
      const res = await authApi.refresh(params);
      if (res.error) throw new Error(SESSION_EXPIRED);
      const { AccessToken, RefreshToken } = res.data;
      localStorage.setItem(
        "access_token",
        JSON.stringify({
          token: AccessToken,
          refresh: RefreshToken ?? refresh,
          username,
        }),
      );
      return AccessToken;
    } catch (error) {
      // The server refused the refresh: the session is over (the API hook
      // signs out on this message). A network error keeps the session, so
      // the user can try again.
      if (error?.response) throw new Error(SESSION_EXPIRED);
      throw error;
    }
  },
};

export default AuthService;
